<template>
    <BottomModal
        :is-visible="modalStore.activeModal === MODAL_QR"
        class="qr-modal"
        title="Video QR"
        description="Quickly share this video or print the QR and place it on a device"
        @close="modalStore?.closeModal"
    >
        <!-- eslint-disable -->
        <img
            :src="QRPng"
            class="qr-modal__img"
        />
         <!-- eslint-enable -->
        <BaseButton
            element="a"
            :download="video.title"
            :href="downloadUrl"
            icon-left="qr"
            gtm-download-qr
            class="base-button--wide"
        >
            Download
        </BaseButton>
    </BottomModal>
</template>

<script setup>
import { useModalStore, MODAL_QR } from '~/store/modal';
import QRCode from 'qrcode';

const QRPng = ref(null);
const modalStore = useModalStore();

const props = defineProps({
    video: {
        type: Object,
        required: true
    }
});

onMounted(() => {
    QRCode.toDataURL(`https://www.medpeers.org/videos/${props.video.id}`, {
        type: 'image/png',
        scale: 16,
        color: {
            dark: '#114A4E',
            light: '#F3FAF9'
        }
    }, function(err, url) {
        QRPng.value = url;
    });
});

const downloadUrl = computed(() => {
    if(QRPng.value) {
        const blob = dataURLtoBlob(QRPng.value);
        return URL.createObjectURL(blob);
    }
});

function dataURLtoBlob(dataurl) {
    const arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type:mime});
}
</script>

<style lang="less">
.qr-modal__img {
    width: 75%;
    margin: var(--spacing-sm) auto;
}
</style>
